/* eslint-disable camelcase */
import { axiosInstance } from '@services/base-service';

const reportsURI = '/merchant/bff';

export const getReports = (accountId) =>
  axiosInstance.getInstance().get(`${reportsURI}/reports?account_id=${accountId}`);

export const getReportsByRange = ({ accountId, dataRange: { startDate, endDate } }) =>
  axiosInstance
    .getInstance()
    .get(
      `${reportsURI}/reports?account_id=${accountId}&start_date=${startDate}&end_date=${endDate}`
    );

export const createReport = ({ account_id, type, start_date, end_date }) =>
  axiosInstance.getInstance().post(`${reportsURI}/reports`, {
    payload: {
      account_id,
      type,
      start_date,
      end_date,
    },
  });

export const scheduledReport = ({ account_id, type }) =>
  axiosInstance.getInstance().post(`${reportsURI}/reports/scheduled`, {
    payload: {
      account_id,
      type,
    },
  });

export const deleteReport = (id) =>
  axiosInstance.getInstance().delete(`${reportsURI}/reports/${id}`);

// https://payments-backoffice-int.fpayapp.com/merchant/bff/reports/reports/602d13c6ae407600220e52a5?from=2023-01-01&page=1&to=2023-01-31&type=TRANSACTIONS
// https://payments-backoffice-int.fpayapp.com/merchant/bff/merchant-reports/reports
